(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["mcd-newsletter-popup"] && !Shopify.designMode) return;
  try {
    (() => {
    const popup = document.querySelector('[data-mcd-newsletter-popup]');
    if (!popup || popup.dataset.initialized === 'true') return;

    popup.dataset.initialized = 'true';
    const panel = popup.querySelector('[data-mcd-newsletter-panel]');
    const closeButtons = popup.querySelectorAll('[data-mcd-newsletter-close]');
    const feedback = popup.querySelector('[data-mcd-newsletter-success], .errors');
    const storageKey = 'mcd-newsletter-popup-dismissed-v2';
    const dismissalLength = 7 * 24 * 60 * 60 * 1000;
    let previousFocus;

    const getDismissedAt = () => {
      try {
        return Number(localStorage.getItem(storageKey) || 0);
      } catch (error) {
        return 0;
      }
    };

    const rememberDismissal = () => {
      try {
        localStorage.setItem(storageKey, String(Date.now()));
      } catch (error) {
        return;
      }
    };

    const openPopup = () => {
      previousFocus = document.activeElement;
      popup.hidden = false;
      document.body.classList.add('mcd-newsletter-popup-open');
      requestAnimationFrame(() => {
        popup.classList.add('is-open');
        panel.focus();
      });
    };

    const closePopup = () => {
      rememberDismissal();
      popup.classList.remove('is-open');
      document.body.classList.remove('mcd-newsletter-popup-open');
      window.setTimeout(() => {
        popup.hidden = true;
        if (previousFocus instanceof HTMLElement) previousFocus.focus();
      }, 220);
    };

    closeButtons.forEach((button) => button.addEventListener('click', closePopup));

    popup.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') {
        closePopup();
        return;
      }

      if (event.key !== 'Tab') return;
      const focusable = [...popup.querySelectorAll('button, input, a[href]')].filter(
        (element) => !element.disabled && element.getClientRects().length,
      );
      if (!focusable.length) return;
      const first = focusable[0];
      const last = focusable[focusable.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    });

    const dismissedRecently = Date.now() - getDismissedAt() < dismissalLength;
    if (feedback || !dismissedRecently) {
      window.setTimeout(openPopup, feedback ? 200 : 2200);
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
